<div class="content-field">
  @switch (field()?.input) {
    @case ('Text') {
      <app-text [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-text>
    }
    @case ('Texts') {
      <app-texts [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-texts>
    }
    @case ('Number') {
      <app-number [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-number>
    }
    @case ('Date') {
      <app-date [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-date>
    }
    @case ('Datetime') {
      <app-datetime [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-datetime>
    }
    @case ('Checkbox') {
      <app-checkbox [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-checkbox>
    }
    @case ('Area') {
      <app-textarea [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-textarea>
    }
    @case ('Email') {
      <app-email [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-email>
    }
    @case ('Image') {
      <app-image [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-image>
    }
    @case ('Images') {
      <app-images [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-images>
    }
    @case ('Color') {
      <app-color [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-color>
    }
    @case ('Slider') {
      <app-slider [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-slider>
    }
    @case ('Toggle') {
      <app-toggle [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-toggle>
    }
    @case ('Select') {
      <app-select [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-select>
    }
    @case ('Dictionary') {
      <app-dictionary [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [readonly]="readonly()"></app-dictionary>
    }
    @case ('Formula') {
      <app-formula [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [content]="$any(node())" [readonly]="readonly()"></app-formula>
    }
    @case ('Picker') {
      <app-content-picker [formGroup]="formGroup()!" [meta]="$safeNavigationMigration(field()?.meta)" [model]="$safeNavigationMigration(field()?.model)" [node]="$any(node())" groupBy="prototype.name" [readonly]="readonly()">
      </app-content-picker>
    }
  }
</div>
